import './chatBotDataToolbar.css';

const ChatBotDataToolbar = ({
    type,
    setType,
    search,
    setSearch,
    onAdd,
    showForm,
    editData,
    onBackfill,
    backfilling
}) => {
    return (
        <div className='cbd-toolbar'>
            <select value={type} onChange={(e) => setType(e.target.value)} className='cbd-select'>
                <option value=''>All Types</option>
                <option value='city'>City</option>
                <option value='destination'>Destination</option>
                <option value='city_and_destination'>City And Destination</option>
                <option value='tripType'>Trip Type</option>
                <option value='offer'>Offer</option>
                <option value='special_offer'>Special Offer</option>
            </select>

            <input
                type='text'
                placeholder='Search name or alias...'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className='cbd-search'
            />

            <button className='cbd-add-btn' onClick={onBackfill} disabled={backfilling}>
                {backfilling ? 'Backfilling...' : '↻ Backfill Trip IDs'}
            </button>

            <button className='cbd-add-btn' onClick={onAdd}>
                {showForm && !editData ? 'Cancel' : '+ Add Data'}
            </button>
        </div>
    );
};

export default ChatBotDataToolbar;
